import React from 'react'
import EmptyState from '../../../components/Cards/EmptyState'
import { MdBuildCircle } from "react-icons/md";
import ResponsiveContainer from '../../../layouts/ResponsiveContainer';

const EvaluationInProgress = () => {
    return (
        <div className='flex justify-center items-center flex-col relative z-458568'>
            <ResponsiveContainer className='mt-4 flex flex-col items-center'>
                <EmptyState
                    message='La evaluación del período será publicada cuando todos los indicadores estén actualizados de acuerdo a la información disponible'
                    showIcon={true}
                    icon={MdBuildCircle}
                    iconSize={20}
                />
            </ResponsiveContainer>
        </div>
    )
}

export default EvaluationInProgress